import { ActiveRentalActions, ShowActiveRentalItem } from '../types/order';
import { CustomError } from '../CustomError';
import { INTERNAL_RENTAL_TYPE_ID, RentalActionKeys } from '../constants/rentals';
import { PostOrderErrorCodes, PostOrderErrorResponse } from '../types/rental';

export const filterRentalActionItems = (
  actions: ActiveRentalActions[],
  rental: ShowActiveRentalItem,
): ActiveRentalActions[] => {
  return actions
    .filter((action) => {
      // Remove all offrent actions for internal rentals
      if (rental?.rental_type_id === INTERNAL_RENTAL_TYPE_ID) {
        return ![
          RentalActionKeys.SCHEDULE_PICKUP,
          RentalActionKeys.RESCHEDULE_PICKUP,
          RentalActionKeys.CANCEL_OFFRENT,
        ].includes(action.key as RentalActionKeys);
      } else if (!rental?.off_rent_date_requested) {
        return action.key !== RentalActionKeys.CANCEL_OFFRENT;
      }

      return true;
    })
    .map((action) => {
      if (!!rental?.off_rent_date_requested && action.key === RentalActionKeys.SCHEDULE_PICKUP) {
        return { ...action, key: RentalActionKeys.RESCHEDULE_PICKUP };
      }
      return action;
    });
};

export const getMinDate = () => new Date().toUTCString();

// default max Date 1 year from now
export const getMaxDate = () => {
  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() + 1);
  return maxDate.toUTCString();
};

export function handleApiError(error: unknown, defaultMessage: string): never {
  if (
    typeof error === 'object' &&
    error !== null &&
    'error_code' in error &&
    'error_message' in error
  ) {
    const typedError = error as PostOrderErrorResponse;

    if (typedError.error_code === PostOrderErrorCodes.PRICE_MISMATCH) {
      throw new CustomError(typedError.error_message, typedError.error_code);
    }

    throw new CustomError(
      typedError.error_message ?? defaultMessage,
      typedError.error_code ?? 'UNKNOWN',
    );
  }

  throw new Error(defaultMessage);
}
